export enum CacheTtl {
  OneSecond = 1_000,
  ThirtySeconds = 30_000,
  OneMinute = 60_000,
  FiveMinutes = 300_000,
  TenMinutes = 600_000,
  ThirtyMinutes = 1_800_000,
  OneHour = 3_600_000,
}
